import React, { useEffect, useRef, useState } from 'react';
import './DetalleServicioModal.scss';
import { getDataMapa, posicionUnidad } from './DetalleServicioIntegracion';
import Map from '../../../../components/molecules/Map/Map';
import { Marker, Polyline, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import { extraerHora } from '../../../../utilities/formateos';

// ── Iconos ────────────────────────────────────────────────────────────────────
import markerImage        from '../../../../components/molecules/Map/assets/red_icon.png';
import markerStop         from '../../../../components/molecules/Map/assets/stop.png';
import markerOficialImg   from '../../../../components/molecules/Map/assets/oficial_icon.png';
import markerNoOficialImg from '../../../../assets/icons/yellow_icon.png';
import markerDescensoImg        from '../../../../assets/icons/descenso.png';
import markerDescensoNoOficialImg from '../../../../assets/icons/descenso_no_oficial.png';
import busMarker     from '../../../../assets/icons/camion.png';
import volante       from '../../../../assets/icons/usuario.png';
import unidadIcon    from '../../../../assets/icons/camion.png';
import iconIncidenciaViaje from '../../../../assets/icons/warning.png';

/* Ajusta el mapa a los límites del trazo (solo una vez al inicio) */
const FitBounds = ({ trazo }) => {
    const map = useMap();
    const hasCentered = useRef(false);

    useEffect(() => {
        if (hasCentered.current) return;
        const puntos = trazo?.trazo ?? trazo?.trazo_waillon?.map((p) => [p.lat, p.lng]);
        if (puntos?.length > 1) {
            try {
                map.fitBounds(L.latLngBounds(puntos), { padding: [30, 30] });
                hasCentered.current = true;
            } catch (_) {}
        }
    }, [trazo, map]);

    return null;
};

const DetalleServicioModal = ({ bitacora, servicio, onClose, incidencias_viaje = [], estatus, userData }) => {
    const [trazo,       setTrazo]       = useState({});
    const [dataModal,   setDataModal]   = useState(null);
    const [posUnidad,   setPosUnidad]   = useState(null);
    const [paradas,     setParadas]     = useState([]);
    const [personaClick, setPersonaClick] = useState(null);
    const [hoverInfo,   setHoverInfo]   = useState(null);
    const personMarkerRefs    = useRef({});
    const incidenciaMarkerRefs = useRef({});

    // Carga inicial
    useEffect(() => {
        if (!bitacora) return;
        getDataMapa(bitacora, setTrazo, setDataModal);
    }, [bitacora]);

    // Polling cada 10 s
    useEffect(() => {
        if (!bitacora) return;
        const interval = setInterval(() => getDataMapa(bitacora, setTrazo, setDataModal), 10000);
        return () => clearInterval(interval);
    }, [bitacora]);

    // Posición unidad en tiempo real
    useEffect(() => {
        if (dataModal?.unidad) {
            posicionUnidad(`suma${dataModal.unidad}`, setPosUnidad);
        }
    }, [dataModal]);

    // Agrupar pasajeros por parada/posición
    useEffect(() => {
        if (!dataModal?.personas) return;
        const output = [];
        let grupo = [];
        for (const persona of dataModal.personas) {
            if (
                grupo.length === 0 ||
                (grupo[0].parada === persona.ID_PARADA &&
                    grupo[0].lat === persona.LATITUD &&
                    grupo[0].lng === persona.LONGITUD)
            ) {
                grupo.push({ parada: persona.ID_PARADA, id_empleado: persona.ID_EMPLEADO, lat: persona.LATITUD, lng: persona.LONGITUD, hora: persona.CREADO, tipo: persona.TIPO });
            } else {
                output.push(grupo);
                grupo = [{ parada: persona.ID_PARADA, id_empleado: persona.ID_EMPLEADO, lat: persona.LATITUD, lng: persona.LONGITUD, hora: persona.CREADO, tipo: persona.TIPO }];
            }
        }
        if (grupo.length > 0) output.push(grupo);
        setParadas(output);
    }, [dataModal]);

    // Resaltar persona seleccionada
    useEffect(() => {
        if (!personaClick || !paradas) return;
        paradas.forEach((p) => p.forEach((item) => {
            const el = document.getElementById(`dsm-${item.id_empleado}${item.lat}${item.lng}`);
            if (el) el.style.color = 'black';
        }));
        const el = document.getElementById(`dsm-${personaClick.ID_EMPLEADO}${personaClick.LATITUD}${personaClick.LONGITUD}`);
        if (el) el.style.color = 'var(--blue10)';
    }, [personaClick]);

    // ── Iconos Leaflet ────────────────────────────────────────────────────────
    const iconParada = (item, key) => L.divIcon({
        className: 'custom-marker',
        html: `
            <img style="width:40px;position:relative" src="${markerImage}"/>
            <div style="position:absolute;top:12px;left:${key < 10 ? '17px' : '14.5px'};font-weight:bold;font-size:0.6rem">${key}</div>
            <div style="width:max-content;padding:2px 5px;border-radius:10px;background:rgba(0,0,0,0.5);position:absolute;left:-35px;">
                <div style="color:white;font-size:11px;">${item.HORARIO}</div>
            </div>`,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
    });

    const iconStop    = new L.Icon({ iconUrl: markerStop,         iconSize: [20, 20], iconAnchor: [16, 32], popupAnchor: [0, -32] });
    const iconOficial = new L.Icon({ iconUrl: markerOficialImg,   iconSize: [20, 20], iconAnchor: [16, 32], popupAnchor: [0, -32] });
    const iconNoOfi   = new L.Icon({ iconUrl: markerNoOficialImg, iconSize: [20, 20], iconAnchor: [16, 32], popupAnchor: [0, -32] });
    const iconDesc    = new L.Icon({ iconUrl: markerDescensoImg,         iconSize: [20, 20], iconAnchor: [16, 32], popupAnchor: [0, -32] });
    const iconDescNoOfi = new L.Icon({ iconUrl: markerDescensoNoOficialImg, iconSize: [20, 20], iconAnchor: [16, 32], popupAnchor: [0, -32] });
    const iconBus     = new L.Icon({ iconUrl: busMarker, iconSize: [50, 25], iconAnchor: [16, 25], popupAnchor: [0, -32] });
    const iconIncidencia = new L.Icon({ iconUrl: iconIncidenciaViaje, iconSize: [30, 30], iconAnchor: [15, 30], popupAnchor: [0, -32] });

    // ── Helpers ───────────────────────────────────────────────────────────────
    const getClosestPoint = (mouseLatLng, points) => {
        let minDist = Infinity, closest = null;
        for (const p of points) {
            const d = mouseLatLng.distanceTo(L.latLng(p.lat, p.lng));
            if (d < minDist) { minDist = d; closest = p; }
        }
        return closest;
    };

    const handleMapClick = (e) => {
        if (!trazo.trazo_waillon) return;
        const closest = getClosestPoint(e.latlng, trazo.trazo_waillon);
        if (closest) setHoverInfo({ latlng: L.latLng(closest.lat, closest.lng), hora: `Hora: ${closest.hora}`, velocidad: `Velocidad: ${closest.velocidad} km/h` });
    };

    const abrirPopup = (index) => personMarkerRefs.current[index]?.openPopup();

    const onPersonaClick = (persona) => {
        const idx = paradas.findIndex((p) => p.some((o) => o.id_empleado === persona.ID_EMPLEADO && o.lat === persona.LATITUD && o.lng === persona.LONGITUD));
        abrirPopup(idx);
        setPersonaClick(persona);
    };

    const onIncidenciaClick = (index) => incidenciaMarkerRefs.current[index]?.openPopup();

    const mostrarUnidad = posUnidad && (
        (userData?.EMPRESA_ASIGNADA == 5 && estatus >= 7) ||
        (userData?.EMPRESA_ASIGNADA != 5 && estatus >= 8)
    );

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <div className="dsm-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="dsm-modal">
                {/* Header */}
                <div className="dsm-header">
                    <span className="dsm-titulo">{servicio || 'Detalle del servicio'}</span>
                    <button className="dsm-cerrar" onClick={onClose}>✕</button>
                </div>

                {/* Cuerpo */}
                <div className="dsm-body">

                    {/* ── Mapa ── */}
                    <div className="dsm-bloque dsm-bloque--mapa">
                        <div className="dsm-bloque-titulo">Mapa en vivo</div>
                        <div className="dsm-mapa-wrap">
                            <Map
                                key={bitacora}
                                center={{ lat: 20.67129241646564, lng: -103.35232101509537 }}
                                zoom={12}
                                scrollWheelZoom
                                style={{ height: '100%', width: '100%', zIndex: 0 }}
                            >
                                <FitBounds trazo={trazo} />

                                {trazo.markers?.map((item, i) => (
                                    <Marker key={`m-${i}`} position={item} icon={iconParada(item, i + 1)}>
                                        <Popup><b>Parada {i + 1}</b><br />{item.NOMBRE}<br />Hora: {item.HORARIO}</Popup>
                                    </Marker>
                                ))}

                                {trazo.stops_wiallon?.map((item, i) => (
                                    <Marker key={`sw-${i}`} position={item} icon={iconStop}>
                                        <Popup>Hora: {item.Hora}</Popup>
                                    </Marker>
                                ))}

                                {mostrarUnidad && (
                                    <Marker position={{ lat: posUnidad.max_lat, lng: posUnidad.max_lon }} icon={iconBus}>
                                        <Popup><b>Unidad:</b> {dataModal?.unidad}<br /><b>Última actualización:</b> {posUnidad.hora}</Popup>
                                    </Marker>
                                )}

                                {paradas.map((grupo, gi) => (
                                    <React.Fragment key={`g-${gi}`}>
                                        {grupo.map((pasajero, si) => {
                                            let icon = iconOficial;
                                            if (!pasajero.parada) icon = iconNoOfi;
                                            if (pasajero.tipo === 0) icon = iconDesc;
                                            if (!pasajero.parada && pasajero.tipo === 0) icon = iconDescNoOfi;
                                            return (
                                                <Marker key={`p-${gi}-${si}`} ref={(el) => (personMarkerRefs.current[gi] = el)} position={pasajero} icon={icon}>
                                                    <Popup>
                                                        {grupo.map((info, ii) => (
                                                            <div key={ii} id={`dsm-${info.id_empleado}${info.lat}${info.lng}`}>
                                                                {info.hora} | {info.id_empleado}
                                                            </div>
                                                        ))}
                                                    </Popup>
                                                </Marker>
                                            );
                                        })}
                                    </React.Fragment>
                                ))}

                                {incidencias_viaje.map((inc, i) => {
                                    if (!inc.LAT || !inc.LON) return null;
                                    return (
                                        <Marker key={`inc-${i}`} ref={(el) => (incidenciaMarkerRefs.current[i] = el)} position={{ lat: parseFloat(inc.LAT), lng: parseFloat(inc.LON) }} icon={iconIncidencia}>
                                            <Popup>
                                                <div style={{ minWidth: '200px' }}>
                                                    <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px' }}>📍 Incidencia #{inc.ID}</div>
                                                    <div style={{ marginBottom: '4px' }}><strong>Descripción:</strong> {inc.DESCRIPCION}</div>
                                                    <div style={{ marginBottom: '4px' }}><strong>Fecha:</strong> {inc.FECHA}</div>
                                                    <div style={{ fontSize: '11px', color: '#666' }}>Lat: {inc.LAT}, Lon: {inc.LON}</div>
                                                </div>
                                            </Popup>
                                        </Marker>
                                    );
                                })}

                                {trazo.trazo?.length > 0 && (
                                    <>
                                        <Polyline pathOptions={{ color: 'red', weight: 7 }} positions={trazo.trazo} />
                                        {trazo.trazo_waillon?.length > 0 && (
                                            <Polyline
                                                pathOptions={{ color: '#20C3E5', weight: 5 }}
                                                positions={trazo.trazo_waillon.map((p) => [p.lat, p.lng])}
                                                eventHandlers={{ click: handleMapClick }}
                                            />
                                        )}
                                        {hoverInfo && (
                                            <Popup position={hoverInfo.latlng} onClose={() => setHoverInfo(null)}>
                                                <div style={{ fontWeight: 'bold' }}>{hoverInfo.hora}</div>
                                                <div style={{ fontWeight: 'bold' }}>{hoverInfo.velocidad}</div>
                                            </Popup>
                                        )}
                                    </>
                                )}
                            </Map>
                        </div>
                    </div>

                    {/* ── Detalles de ruta ── */}
                    <div className="dsm-bloque dsm-bloque--detalles">
                        <div className="dsm-bloque-titulo">Detalles de la ruta</div>
                        {dataModal ? (
                            <div className="dsm-detalles">
                                <div className="dsm-det-fila">
                                    <img src={volante} alt="" width={30} />
                                    <span>{dataModal.operador}</span>
                                </div>
                                <div className="dsm-det-fila">
                                    <img src={unidadIcon} alt="" width={26} />
                                    <span>Unidad {dataModal.unidad} &nbsp;·&nbsp; Bitácora <b>{dataModal.id_bitacora}</b></span>
                                </div>
                                <hr />
                                <div className="dsm-det-grid">
                                    <div className="dsm-det-item">
                                        <label>Inicio programado</label>
                                        <span>{dataModal.horaDeInicio || '—'}</span>
                                    </div>
                                    <div className="dsm-det-item">
                                        <label>Arribo programado</label>
                                        <span>{dataModal.horaLlegada || '—'}</span>
                                    </div>
                                    <div className="dsm-det-item">
                                        <label>Inicio de ruta</label>
                                        <span>{extraerHora(dataModal.hora_arranque) || '—'}</span>
                                    </div>
                                    <div className="dsm-det-item">
                                        <label>Fin de ruta</label>
                                        <span>{trazo.enProceso ? 'En proceso' : (extraerHora(dataModal.hora_fin_real) || '—')}</span>
                                    </div>
                                    <div className="dsm-det-item">
                                        <label>Capacidad</label>
                                        <span style={{ color: 'green', fontWeight: 600 }}>{dataModal.capacidad}</span>
                                    </div>
                                    <div className="dsm-det-item">
                                        <label>Asientos disponibles</label>
                                        <span style={{ color: 'green', fontWeight: 600 }}>{dataModal.asientos_disponibles}</span>
                                    </div>
                                </div>

                                {incidencias_viaje?.length > 0 && (
                                    <>
                                        <hr style={{ margin: '12px 0' }} />
                                        <div className="dsm-bloque-titulo" style={{ fontSize: '13px', marginBottom: '8px' }}>
                                            Incidencias de viaje
                                            <span className="dsm-badge" style={{ marginLeft: '8px', background: '#ef4444' }}>
                                                {incidencias_viaje.length}
                                            </span>
                                        </div>
                                        <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                            {incidencias_viaje.map((inc, i) => (
                                                <div key={inc.ID ?? i} onClick={() => onIncidenciaClick(i)}
                                                    style={{ padding: '8px', marginBottom: '6px', background: '#fef2f2', borderLeft: '3px solid #ef4444', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#fee2e2')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.background = '#fef2f2')}
                                                >
                                                    <div style={{ fontWeight: 'bold', color: '#991b1b', marginBottom: '2px' }}>{inc.DESCRIPCION}</div>
                                                    <div style={{ color: '#666', fontSize: '11px' }}>🕐 {inc.FECHA}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="dsm-cargando">Cargando detalles...</div>
                        )}
                    </div>

                    {/* ── Pasajeros ── */}
                    <div className="dsm-bloque dsm-bloque--pasajeros">
                        <div className="dsm-bloque-titulo">
                            Pasajeros &nbsp;
                            <span className="dsm-badge">
                                {dataModal?.personas?.filter((p) => p.TIPO === 1).length ?? 0}
                            </span>
                        </div>
                        <div className="dsm-pasajeros-lista">
                            {dataModal?.personas?.length > 0 ? dataModal.personas.map((item, i) => {
                                const noOficial = item.PARADA_NOMBRE === 'Parada no oficial';
                                const descenso  = item.TIPO === 0;
                                return (
                                    <div key={i} className={`dsm-pasajero ${descenso ? 'dsm-pasajero--desc' : ''}`} onClick={() => onPersonaClick(item)}>
                                        <div className={`dsm-punto ${noOficial ? 'dsm-punto--amarillo' : ''} ${descenso ? 'dsm-punto--descenso' : ''}`} />
                                        <div className="dsm-pasajero-info">
                                            <div><b>ID:</b> {item.ID_EMPLEADO}</div>
                                            <div><b>Nombre:</b> {item.NOMBRE_EMPLEADO}</div>
                                            <div><b>Parada:</b> {item.PARADA_NOMBRE}</div>
                                            <div id={`dsm-${item.ID_EMPLEADO}${item.LATITUD}${item.LONGITUD}`}>
                                                <span className={descenso ? 'dsm-label-desc' : 'dsm-label-abordo'}>
                                                    {descenso ? 'Descendió:' : 'Abordó:'}&nbsp;
                                                </span>
                                                {item.CREADO}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) : (
                                <div className="dsm-cargando">Sin pasajeros registrados</div>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default DetalleServicioModal;
